// @ts-nocheck







import CommonApi from '../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';
import { downloadRequestWithToken, fetchRequest } from './index';

export const convertDataToServer = (
batteryCalculation) => (
{
  ...batteryCalculation,
  sum: convertFromRubToKop(batteryCalculation.sum),
  months: batteryCalculation.months.map(
    convertDataToServerBatteryCalculationMonth
  )
});

export const convertDataFromServer = (
batteryCalculation) => (
{
  ...batteryCalculation,
  sum: convertFromKopToRub(batteryCalculation.sum),
  months: batteryCalculation.months.map(
    convertDataFromServerBatteryCalculationMonth
  )
});

export const convertDataToServerBatteryCalculationMonth = (
batteryCalculationMonth) => (
{
  ...batteryCalculationMonth,
  cost: convertFromRubToKop(batteryCalculationMonth.cost)
});

export const convertDataFromServerBatteryCalculationMonth = (
batteryCalculationMonth) => (
{
  ...batteryCalculationMonth,
  cost: convertFromKopToRub(batteryCalculationMonth.cost)
});

const basedUrl = 'batteryCalculation';
const batteryCalculation = new CommonApi(
  basedUrl,
  'расчет стоимости замены АКБ',
  convertDataToServer,
  convertDataFromServer
);

const calculate = async (vehiclePlanId) => {
  const updated = await fetchRequest.put(
    `/${basedUrl}/calculate/${vehiclePlanId}`
  );
  if (updated) return updated;
  throw new Error(`Не удалось произвести расчет`);
};

const changeStatus = async (
vehiclePlanId,
status) =>
{
  const updated = await fetchRequest.put(`/${basedUrl}/changeStatus`, {
    vehiclePlanId,
    status
  });
  if (updated) return updated;
  throw new Error(`Не удалось сменить статус расчет`);
};

const print = async (vehiclePlanId, filter) => {
  const print = await downloadRequestWithToken(`/batteryCalculation/print`, {
    ...filter,
    vehiclePlanId
  });
  if (print) return print;
  throw new Error('Не удалось распечатать месячный план');
};

export default {
  ...batteryCalculation,
  print,
  calculate,
  changeStatus
};
